/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Trial_TitleInputs */

const en_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial Mode`)
};

const fr_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode d'essai`)
};

const de_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testmodus`)
};

const it_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità di prova`)
};

const ru_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробный режим`)
};

const es_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de prueba`)
};

const zh_cn2_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用模式`)
};

const ja_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルモード`)
};

const hi_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परीक्षण मोड़`)
};

const pt_pt2_dialogue_list_export_trial_title = /** @type {(inputs: Dialogue_List_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de teste`)
};

/**
* | output |
* | --- |
* | "Trial Mode" |
*
* @param {Dialogue_List_Export_Trial_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_trial_title = /** @type {((inputs?: Dialogue_List_Export_Trial_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Trial_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_trial_title(inputs)
	if (locale === "de") return de_dialogue_list_export_trial_title(inputs)
	if (locale === "it") return it_dialogue_list_export_trial_title(inputs)
	if (locale === "ru") return ru_dialogue_list_export_trial_title(inputs)
	if (locale === "es") return es_dialogue_list_export_trial_title(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_trial_title(inputs)
	if (locale === "ja") return ja_dialogue_list_export_trial_title(inputs)
	if (locale === "hi") return hi_dialogue_list_export_trial_title(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_trial_title(inputs)
	return en_dialogue_list_export_trial_title(inputs)
});